import { useState } from "react";
import { PhoneCall, X } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { TIMEZONE } from "../data/contact";
import { ContactFields, EMPTY_CONTACT, validateContact, trimContact } from "./ContactFields";
import { trackLeadConversion } from "../lib/gtag";

export default function CallbackModal({ open, onClose }) {
  const [form, setForm] = useState(EMPTY_CONTACT);
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  if (!open) return null;

  const submit = async () => {
    const err = validateContact(form);
    if (err) return toast.error(err);
    setSending(true);
    try {
      await api.post("/leads", { type: "callback", ...trimContact(form), data: { timezone: TIMEZONE } });
      trackLeadConversion("callback");
      setDone(true);
    } catch {
      toast.error("Something went wrong — please try again");
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/70 backdrop-blur-sm p-4" onClick={onClose} data-testid="callback-modal">
      <div className="w-full max-w-sm rounded-lg border border-gold/25 bg-obsidian-800 p-6 noise" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-neon">Speedy Resurfacing</p>
            <h3 className="mt-2 font-heading font-black text-2xl">{done ? "LOCKED IN." : "WE'LL CALL YOU BACK."}</h3>
          </div>
          <button onClick={onClose} data-testid="callback-close" className="text-zinc-500 hover:text-white"><X size={20} /></button>
        </div>

        {done ? (
          <p className="mt-4 text-sm text-zinc-300" data-testid="callback-confirmation">
            Thanks {form.contact_name.trim().split(" ")[0]} — Speedy Resurfacing will call you on {form.phone.trim()} shortly. Talk soon.
          </p>
        ) : (
          <div className="mt-5 space-y-4">
            <p className="text-sm text-zinc-400">Leave your details and a Speedy specialist will ring you back.</p>
            <ContactFields form={form} set={set} testid="callback" compact />
            <button onClick={submit} disabled={sending} data-testid="callback-submit"
              className="w-full inline-flex items-center justify-center gap-2 rounded-sm bg-neon px-5 py-3.5 font-bold text-obsidian hover:bg-neon-hover transition-colors disabled:opacity-60">
              <PhoneCall size={16} /> {sending ? "Sending…" : "Request Callback"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
